<section>
  <div class="jumbotron">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="jumbotron-body">
            <p>
              <!-- In order to maintain NYCHA developments in good, livable conditions, we regularly make
              capital investments to renovate and modernize apartments and building interiors,
              building systems and exteriors, site security and grounds. NYCHA typically manages
              more than 500 active construction projects at any time at the Authority’s properties
              throughout the city. Learn more about the capital projects and capital needs at your
              development, in your district or borough, or throughout the city, by using this
              Capital Projects & Needs Tracker. -->
              To maintain NYCHA developments in good, livable condition, we regularly make capital
              investments to renovate and modernize apartments and building interiors, building
              systems and exteriors, and site security and grounds. NYCHA typically manages more
              than 500 active capital projects at any time. Learn more about the capital projects
              and capital needs at your development, in your district or borough, or throughout the
              city, by using this Capital Projects & Needs Tracker.
            </p>
            <!-- <ul>
              <li>
                To find information on a specific development, search for the development name,
                click on the development on the map, or click on the development name on the
                Developments list.
              </li>
              <li>
                To find all developments in a borough, or City Council district, with projects
                funded by a specific funding source, or projects with a specific project status,
                click on the categories you want to filter the Developments list.
              </li>
            </ul> -->
            <!-- <p>
              <span
                >If a development has been converted or is planned to be converted under the
                Permanent Affordability Commitment Together (PACT) program, you can find information
                on that development on the
                <a
                  href="https://experience.arcgis.com/experience/66a6bbe303db433b978370b1191046f7/"
                  target="_blank"
                  class="header-a-link"
                  >PACT Interactive Map</a
                >. If you cannot find information about a development or project you are looking
                for, please
                <a
                  [routerLink]="['/contact']"
                  routerLinkActive="active"
                  class="header-a-link"
                  aria-current="page"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >Contact NYCHA</a
                >.
              </span>
            </p> -->
            <p>
              <span
                >Information on developments that are converted or are converting through the
                Permanent Affordability Commitment Together (PACT) program can be found on NYCHA's
                <a
                  href="https://www.nyc.gov/site/nycha/about/pact.page"
                  target="_blank"
                  class="header-a-link"
                  >PACT Program page</a
                >. Developments converting through PACT with active, ongoing capital projects are
                also included on this Tracker. If you cannot find information about a development or
                project, please
                <a
                  [routerLink]="['/contact']"
                  routerLinkActive="active"
                  class="header-a-link"
                  aria-current="page"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >Contact NYCHA</a
                >.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container landing-page">
    <div class="row-wrapper">
      <div class="search-form">
        <div class="row">
          <div class="col-md-12">
            <h4 class="mb-3">Search for a specific development</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="input-group mb-5">
              <span class="input-group-text"><i class="icon icon-magnifier"></i></span>
              <input
                class="form-control"
                list="developmentListOptions"
                id="searchInput"
                placeholder="Development Name"
                autocomplete="off"
                type="text"
                [(ngModel)]="searchValue"
                (change)="searchDevelopment(searchValue)"
              />
              <datalist id="developmentListOptions">
                <option
                  *ngFor="let item of developmentList"
                  [value]="item.name"
                  class="skiptranslate"
                >
                  {{ item.name }}
                </option>
              </datalist>

              <label
                for="searchInput"
                class="input-group-text input-primary skiptranslate"
                (click)="searchDevelopment(searchValue)"
              >
                Search
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h4 class="mb-3">Or filter developments by the categories below</h4>
          </div>
        </div>

        <div class="row">
          <div class="d-flex col-md-12">
            <div class="row col-wrapper">
              <div class="col-md-3">
                <div class="dropdown d-grid">
                  <button
                    type="button"
                    class="btn btn-md btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <span>Borough</span>
                    <i class="icon icon-chevron"></i>
                  </button>

                  <ul class="dropdown-menu">
                    <li *ngFor="let borough of boroughList" class="dropdown-item py-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="borough.id"
                          [value]="borough.label"
                          [checked]="borough.checked"
                          (change)="checkDropDown('borough', borough)"
                        />
                        <label class="form-check-label skiptranslate" [for]="borough.id">{{
                          borough.label
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-3">
                <div class="dropdown d-grid">
                  <button
                    type="button"
                    class="btn btn-md btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <span>Council District</span>
                    <i class="icon icon-chevron"></i>
                  </button>

                  <ul class="dropdown-menu">
                    <li *ngFor="let district of councilDistrictList" class="dropdown-item py-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="district.id"
                          [value]="district.label"
                          [checked]="district.checked"
                          (change)="checkDropDown('district', district)"
                        />
                        <label class="form-check-label" [for]="district.id">
                          {{ district.label }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-3">
                <div class="dropdown d-grid">
                  <button
                    type="button"
                    class="btn btn-md btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <span>Funding Source</span>
                    <i class="icon icon-chevron"></i>
                  </button>

                  <ul class="dropdown-menu">
                    <li *ngFor="let funding of fundingSourceList" class="dropdown-item py-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="funding.id"
                          [value]="funding.label"
                          [checked]="funding.checked"
                          (change)="checkDropDown('funding', funding)"
                        />
                        <label class="form-check-label" [for]="funding.id">{{
                          funding.label
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-3">
                <div class="dropdown d-grid">
                  <button
                    type="button"
                    class="btn btn-md btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <span>Project Status</span>
                    <i class="icon icon-chevron"></i>
                  </button>

                  <ul class="dropdown-menu">
                    <li *ngFor="let status of projectStatusList" class="dropdown-item py-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="status.id"
                          [value]="status.label"
                          [checked]="status.checked"
                          (change)="checkDropDown('status', status)"
                        />
                        <label class="form-check-label" [for]="status.id">
                          {{ status.label }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="d-none d-md-block col-md-auto ms-2">
              <button class="btn btn-icon" type="button" (click)="resetFilters()">
                <div class="icon icon-reset-round"></div>
              </button>
            </div>

            <div class="d-md-none">
              <button class="btn btn-icon" type="button" (click)="resetFilters()">
                <div></div>
                <span>Reset Filters</span>
                <div class="icon icon-reset"></div>
              </button>
            </div>
          </div>
        </div>
        <div class="row padding-40">
          <div class="col-md-12">
            <h4 class="mb-3">Or click on a development from the list on the right</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 col-sm-12">
          <div class="map">
            <app-arcgis-map
              (mapLoaded)="mapLoadedEvent($event)"
              [moveTo]="centeredMap"
              [zoom]="mapZoomLevel"
              (selectedDevelopment)="loadDevelopmentSummary($event)"
              [inputDevelopmentId]="selectedDevelopment?.id || 0"
            ></app-arcgis-map>
          </div>
        </div>

        <div
          *ngIf="!selectedDevelopment"
          class="col-lg-4 col-sm-12"
          id="no-development-selected-id"
        >
          <div class="card mb-5">
            <h4 class="card-title d-grid mb-0">Developments</h4>

            <div class="card-body px-0 py-0">
              <div class="list-group list-group-flush">
                <button
                  *ngFor="let item of filteredDevelopmentList; index as i"
                  type="button"
                  class="list-group-item list-group-item-action skiptranslate"
                  [ngClass]="{ highlight: i % 2 === 0 }"
                  (click)="loadDevelopmentSummary(item.id)"
                >
                  {{ item.name }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-12" id="development-summary-id">
          <ng-container *ngIf="selectedDevelopment">
            <app-development-summary
              [development]="selectedDevelopment"
              [selectedProjectStatus]="selectedProjectStatus"
              (closeModal)="closeModal()"
            ></app-development-summary>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid jumbotron">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="jumbotron-body jumbotron-footerfont">
            <p>
              <span
                >The data shown on this site is accurate as of the date shown above. Due to systems
                constraints, a subset of capital projects are currently not presented here: projects
                for which funds are not yet available to NYCHA, projects completed before 2019,
                emergency projects, projects on NYCHA properties managed by other government
                agencies or non-profits, and project records with data quality issues. Projects
                undertaken as part of the Superstorm Sandy recovery and storm resiliency efforts are
                also excluded from this site; details about these projects can be found at
                <a
                  href="https://www1.nyc.gov/site/nycha/about/recovery-resiliency.page"
                  target="_blank"
                  class="header-a-link"
                  >NYCHA Recovery & Resilience</a
                >.</span
              >
            </p>
            <p>
              In addition, planned start and end dates shown for each project may reflect schedule
              re-baselining undertaken as per NYCHA internal policies, rather than the original
              schedule developed for that project. Construction phase dates and progress shown for
              projects incorporate pre-construction preparation activities, not only physical
              construction, and project completion is defined as 100% physical construction
              completion excluding additional project closeout activities that may be required. As a
              result of these and other limitations, the Capital Projects & Needs Tracker is not an
              analysis tool and the data is intended to be used for stakeholder information purposes
              only.
            </p>
            <p>
              The Capital Projects Tracker works best on the following web browsers: Chrome 93 or
              later, Edge 93 or later, Firefox 93 or later, and Safari 15.2 or later.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <div
  class="modal fade"
  id="contactModal"
  tabindex="-1"
  aria-labelledby="contactModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <app-contact
          [projectId]="projectId"
          [developmentName]="developmentName"
          (closeModal)="closeModal()"
        ></app-contact>
      </div>
    </div>
  </div>
</div> -->
